import   React                            ,
       { useState                         ,
         useEffect                        ,
         useRef                           }  from "react";

import   classNames                          from "classnames";

import   styles                              from "./Audience.module.scss";


import { LiveSession                      ,
         ReplaySession                    ,
         GetSessionsParams                ,
	   	 SessionActivity                  }  from "../../../../dataTypes/customerFrontEventManagment/types"

import { getLiveSessions                  ,
         getReplaySessions                ,
	     computeSessionActivity           ,
         computeSessionActivityEvolution  }  from '../../../../dataTypes/customerFrontEventManagment/utils';

import { Coordinate                       }  from "../../../../dataTypes/geolocationManagment/types"
import { fetchAudienceMapPoints           }  from "../../../../dataTypes/statisticsV2Managment/audienceMap"




import { convertDateToString              ,
         convertStringToDate              ,
         timeStepNames                        }  from '../../../../dataTypes/timeManagment/utils';

import { ChartData                }  from "../../../../dataTypes/dataSetManagment/regroupData";

import   CartesianGraph                      from "../../../widget/dataDisplay/charts/CartesianGraph";
import   OpenStreetMap                       from "../../../widget/dataDisplay/maps/OpenStreetMap";
import   ExtendablePanel                     from "../../../widget/windows/ExtendablePanel";
import   Select                              from '../../../widget/inputs/Select';
import   AnimatedWaitingIcon                 from '../../../widget/animations/animatedWaitingIcon';
import   Field                               from '../../../widget/inputs/Field';

import { useTypedSelector                 }  from '../../../../store/useTypeSelector';
import { RootState                        }  from '../../../../store/generalReducer';



const Audience: React.FC = () => {

  // L'abonnement existait déjà (sans usage) ; la carte s'en sert pour l'identifiant admin.
  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);
  const adminId = authentication.admin?.id ?? null;

  // ~~~~~~ Calcul hauteur
  
  const [widthAudienceBlock, setWidthAudienceBlock] = useState(0);
  const divRefAudienceBlock = useRef<HTMLDivElement>(null);
 
  useEffect(() => {
    
	const handleResize = () => {
    
	if (divRefAudienceBlock.current) 
	 {
      const measuredWidth = divRefAudienceBlock.current.offsetWidth;
      setWidthAudienceBlock(measuredWidth);
     }
    };

    const resizeObserver = new ResizeObserver(handleResize);

    if (divRefAudienceBlock.current) 
	 {
      resizeObserver.observe(divRefAudienceBlock.current);
     }

    handleResize();

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // ~~~~~~ Variables

  const periodNames: string[] = ["Heure glissante", "Jour courant", "Semaine courante", "Mois courant", "Personnaliser"]

  const [ selectedAudiencePeriod      , setSelectedAudiencePeriod      ] = useState (periodNames[3])
  const [ selectedAudiencePeriodIndex , setSelectedAudiencePeriodIndex ] = useState (3)
  const [ selectedAudienceTimeStep    , setSelectedAudienceTimeStep    ] = useState ('1 jour')

  const [ audienceCoordinates         , setAudienceCoordinates         ] = useState<Coordinate[]> ([])
  const [ audienceChartData           , setAudienceChartData           ] = useState<ChartData[]>  ([])

  const [ showWaitingIcon             , setShowWaitingIcon             ] = useState(true)
  const [ mapUpdatedAt                , setMapUpdatedAt                ] = useState<Date | null>(null)

  let replaySessionListCpy : ReplaySession[]
  let liveSessionListCpy   : LiveSession[]
  
  const serieVisibilityRef   = useRef<boolean[]>([ true, true ]);
  const replayCoordinatesRef = useRef<Coordinate[]>([]);
  const liveCoordinatesRef   = useRef<Coordinate[]>([]);

  let now               = new Date ();
  //let nowBis            = new Date (now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes()-1 , 0);
  let rollingHourStart  = new Date (now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() -1, now.getMinutes() , now.getSeconds());
  let currentDayStart   = new Date (now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  let rollingWeekStart  = new Date (now.getFullYear(), now.getMonth(), now.getDate()-7, now.getHours(), now.getMinutes() , now.getSeconds());
  let currentMonthStart = new Date (now.getFullYear(), now.getMonth(), 1, 0, 0, 0);

  const [ customStartDate , setCustomStartDate ] = useState (convertDateToString(currentMonthStart, "dd/MM/yyyy",''))
  const [ customEndDate   , setCustomEndDate   ] = useState (convertDateToString(now, "dd/MM/yyyy",''))

  // ~~~~~~ Group functions


  const generateAudienceCoordinatesReplaySession = (replaySessionList : ReplaySession[]) :Coordinate [] => {

    const coords = replaySessionList.map(session => ({
        lat   :    session.ipAddressLat  || 0,
        lng   :    session.ipAddressLon  || 0,
        info1 :    convertDateToString (session.startDate, 'dd/MM/yyyy HH:mm:ss' ), // session.ipAddress     || "N/A",
        info2 : `${session.userFirstname || "N/A"} ${session.userLastname || "N/A"}`,
        color : "var(--color-Graph-Replay)" 
      }));
      
    return coords  
  }

  const generateAudienceCoordinatesLiveSession = (liveSessionList : LiveSession []) :Coordinate [] => {

    const coords = liveSessionList.map(session => {


       return {
                lat   : session.ipAddressLat || 0,
                lng   : session.ipAddressLon || 0,
                info1 : convertDateToString (session.startDate, 'dd/MM/yyyy HH:mm:ss'), // session.ipAddress     || "N/A",
                info2 : `${session.userFirstname || "N/A"} ${session.userLastname || "N/A"}`,
                color : "var(--color-Graph-Live)"
              };
    });
    
    return coords  
  }

  const mergeCoordinates = ( audienceCoordinatesReplaySession : Coordinate [] ,
                             audienceCoordinatesLiveSession   : Coordinate [] ) => {
      
    const unique = new Map<string, Coordinate>();
    const makeKey = (c: Coordinate) => `${c.lat}:${c.lng}:${c.info1}:${c.info2}`;

    if ( serieVisibilityRef.current[0] ) for (const c of audienceCoordinatesReplaySession) { unique.set(makeKey(c), c); }
    if ( serieVisibilityRef.current[1] ) for (const c of audienceCoordinatesLiveSession  ) { unique.set(makeKey(c), c); }

    const coords = Array.from(unique.values())

    setAudienceCoordinates ( coords )
	
  }
 
   const getRenderer = (val: Date): string => {

    switch (selectedAudienceTimeStep)
      {
       case "1 minute"   :                                    return `${convertDateToString(val, "HH:mm",'')}`
       case "5 minutes"  :                                    return `${convertDateToString(val, "HH:mm",'')}`
       case "10 minutes" :                                    return `${convertDateToString(val, "HH:mm",'')}`
       case "1 heure"    : if (selectedAudiencePeriodIndex<2) return `${convertDateToString(val, "HH",'')}:00`
	                          else                              return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "6 heures"   : if (selectedAudiencePeriodIndex<2) return `${convertDateToString(val, "HH",'')}:00`
	                          else                              return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "12 heures"  : if (selectedAudiencePeriodIndex<2) return `${convertDateToString(val, "HH",'')}:00`
	                          else                              return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "1 jour"     :                                    return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "1 semaine"  :                                    return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "2 semaines" :                                    return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "1 mois"     :                                    return `${convertDateToString(val, "MM/yyyy",'')}`
       case "6 mois"     :                                    return `${convertDateToString(val, "MM/yyyy",'')}`
       case "1 an"       :                                    return `${convertDateToString(val, "yyyy",'')}`
       default           : throw new Error(`Unsupported timeStep: ${selectedAudienceTimeStep}`)
      }
  };

  const mergeSessionActivityTimeline = ( replaySessionActivityTimeline : SessionActivity [] ,
                                         liveSessionActivityTimeline   : SessionActivity [] ) => {

    const allDatesSet = new Set<number>();

    replaySessionActivityTimeline.forEach (item => { allDatesSet.add(item.date.getTime()); });
    liveSessionActivityTimeline.  forEach (item => { allDatesSet.add(item.date.getTime()); });

    const allDates = Array.from(allDatesSet).sort();

    const replayMap = new Map<number, number>();
    const liveMap   = new Map<number, number>();

    replaySessionActivityTimeline.forEach(item => {
      replayMap.set(item.date.getTime(), item.activity ?? 0);
    });

    liveSessionActivityTimeline.forEach(item => {
      liveMap.set(item.date.getTime(), item.activity ?? 0);
    });

    const chart = allDates.map(time => {

      const vr = replayMap.get(time) ?? 0;
      const vl = liveMap.get(time) ?? 0;

      return {
        group: getRenderer (new Date (time) ),
        series: [
          { name: 'Replay', value: vr },
          { name: 'Live', value: vl }
        ]
      };
    });

    setAudienceChartData(chart);
  };

  // ~~~~~~ Fetch data function

  const fetchSessionsDatas = async (params: GetSessionsParams = {}) => {

    now               = new Date ();
   // nowBis            = new Date (now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes()-1 , 0);
    rollingHourStart  = new Date (now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() -1, now.getMinutes() , now.getSeconds());
    currentDayStart   = new Date (now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    rollingWeekStart  = new Date (now.getFullYear(), now.getMonth(), now.getDate()-7, 0, 0 , 0);
    currentMonthStart = new Date (now.getFullYear(), now.getMonth(), 1, 0, 0, 0);

    let audiencePeriodStartDate : Date = rollingHourStart
    let audiencePeriodEndDate   : Date = now

    switch ( selectedAudiencePeriodIndex )
     {
      case 0 : // Heure glissante

               audiencePeriodStartDate = rollingHourStart
               audiencePeriodEndDate   = now
               break;

      case 1 : // Jour courant

               audiencePeriodStartDate = currentDayStart
               audiencePeriodEndDate   = now
               break;

      case 2 : // Semaine courante

               audiencePeriodStartDate = rollingWeekStart
               audiencePeriodEndDate   = now
               break;

      case 3 : // Mois courant

               audiencePeriodStartDate = currentMonthStart
               audiencePeriodEndDate   = now
               break;

      case 4 : // Période personnalisée

               audiencePeriodStartDate = convertStringToDate (customStartDate , "dd/MM/yyyy") ?? currentMonthStart
               audiencePeriodEndDate   = convertStringToDate (customEndDate   , "dd/MM/yyyy") ?? now
               break;
     }

    const updatedParams: GetSessionsParams = {
      ...params,
      beginningDate : audiencePeriodStartDate,
      endingDate    : audiencePeriodEndDate
    };

    // La carte vient des statistiques V2 (CustomerFrontEvent, source des sessions ci-dessous,
    // ne reçoit plus rien depuis le 2026-08-07). Lancée sans attendre le graphique, qui reste
    // sur l'ancienne source et plus lent : la carte s'affiche dès que ses relevés répondent.
    if ( adminId !== null )
     {
      fetchAudienceMapPoints ( adminId , audiencePeriodStartDate , audiencePeriodEndDate )
        .then ( points => {
          replayCoordinatesRef.current = points.replay;
          liveCoordinatesRef.current   = points.live;
          mergeCoordinates ( points.replay , points.live );
          setMapUpdatedAt ( new Date () );
        })
        .catch ( () => { /* on garde la carte affichée jusqu'au prochain relevé */ } );
     }

    try
     {
      setShowWaitingIcon (true);

      const [ getReplaySessionsResult ,
              getLiveSessionsResult   ] = await Promise.all ([ getReplaySessions (updatedParams) ,
                                                               getLiveSessions   (updatedParams) ]);

      replaySessionListCpy = getReplaySessionsResult;
      liveSessionListCpy   = getLiveSessionsResult;


	  /*
      mergeChartData   ( generateAudienceChartDataReplaySession (replaySessionListCpy) ,
	                     generateAudienceChartDataLiveSession   (liveSessionListCpy)   )
      */



  
	  mergeSessionActivityTimeline ( computeSessionActivityEvolution ( computeSessionActivity (replaySessionListCpy) , selectedAudienceTimeStep , audiencePeriodStartDate , audiencePeriodEndDate ) ,
	                                 computeSessionActivityEvolution ( computeSessionActivity (liveSessionListCpy)   , selectedAudienceTimeStep , audiencePeriodStartDate , audiencePeriodEndDate ) )
									 
	  
      setShowWaitingIcon (false);
     }
    catch (error)
     {
      console.error("Erreur lors de la récupération des sessions :", error);
      setShowWaitingIcon (false);
     }
  };

  // ~~~~~~ Timer

  const intervalRef_SessionsDatas = useRef<NodeJS.Timeout | null>(null);
    
  useEffect(() => {
    
	
    fetchSessionsDatas(); // Appel initial

    intervalRef_SessionsDatas.current = setInterval(fetchSessionsDatas, 60000); // 60000 milliseconds = 1 minute

    return () => {
		
      if (intervalRef_SessionsDatas.current) 
	   {
        clearInterval(intervalRef_SessionsDatas.current); // Nettoyage de l'intervalle lors du démontage du composant
       }
    };

  }, [ selectedAudiencePeriodIndex , selectedAudienceTimeStep , customStartDate, customEndDate , adminId ]);

  // Onglet resté en arrière-plan : on rattrape tout de suite au retour (comme les stats V2).
  const refreshOnReturnRef = useRef<() => void>(() => {});
  refreshOnReturnRef.current = () => { fetchSessionsDatas(); };

  useEffect(() => {
    const onReturn = () => { if (!document.hidden) refreshOnReturnRef.current(); };
    document.addEventListener('visibilitychange', onReturn);
    return () => document.removeEventListener('visibilitychange', onReturn);
  }, []);

/*
  useEffect(() => {

    fetchSessionsDatas(); // Appel initial

    intervalRef_SessionsDatas.current = setInterval(fetchSessionsDatas, 60000); // 60000 milliseconds = 1 minute

    return () => {

      if (intervalRef_SessionsDatas.current)
	   {
        clearInterval(intervalRef_SessionsDatas.current); // Nettoyage de l'intervalle lors du démontage du composant
       }
    };
  }, [  ]);

  // ~~~~~~ useEffect functions

  useEffect(() => {

  //  setShowWaitingIcon (true);

    mergeChartData ( generateAudienceChartDataReplaySession (replaySessionListCpy) ,
	                 generateAudienceChartDataLiveSession   (liveSessionListCpy)   )

  //  setShowWaitingIcon (false);

  }, [selectedAudienceTimeStep]);

  useEffect(() => {


  }, [selectedAudienceTimeStep]);
*/

  // ~~~~~~ Handles to specify period

  const handleAudiencePeriodChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      
 
    setSelectedAudiencePeriod      ( e.target.value );
    setSelectedAudiencePeriodIndex ( e.target.selectedIndex - 1 );  // On décale de 1 pour tenir compte du placeholder à l'indice 0
  };

  const handleAudiencePeriodStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    setCustomStartDate ( event.target.value )
  }

  const handleAudiencePeriodEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    setCustomEndDate ( event.target.value )
  }

  const handleSelectedAudienceTimeStepChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedAudienceTimeStep(e.target.value);
  };

  // ~~~~~~ Audience chart

  const generateAudienceBarGraphTitle = () : string => {

    return `Audiences`
  }

  const generateAudienceBarGraphSubTitle = () : string => {

    let finalSubTitle = '';

    switch ( selectedAudiencePeriodIndex )
     {
      case 0 : // Heure courante

               finalSubTitle = `De ${(convertDateToString (rollingHourStart ,'HH:mm'))} à ${(convertDateToString (now ,'HH:mm'))}`
               
               switch ( selectedAudienceTimeStep ) 
                {
                 case "1 minute"   : finalSubTitle += ' par minute';                break; 
                 case "5 minutes"  : finalSubTitle += ' par tranche de 5 minutes';  break;
                 case "10 minutes" : finalSubTitle += ' par tranche de 10 minutes'; break;
                 // case "1 heure"    : finalSubTitle += ' par heure';                 break;
                 // case "6 heures"   : finalSubTitle += ' par tranche de 6 heures';   break;
                 // case "12 heures"  : finalSubTitle += ' par tranche de 12 heures';  break;
                 // case "1 jour"     : return (session: LiveSession) => ({
                 // case "1 semaine"  : return (session: LiveSession) => ({
                 // case "2 semaines" : return (session: LiveSession) => ({
                 // case "1 mois"     : return (session: LiveSession) => ({
                 // case "6 mois"     : return (session: LiveSession) => ({
                 // case "1 an"       : return (session: LiveSession) => ({
                }
                
               break;
		 
      case 1 : // Jour courant

               finalSubTitle = `Du ${(convertDateToString (now ,'dd/MM/yyyy')) }`
               
               switch ( selectedAudienceTimeStep ) 
                {
                 case "1 minute"   : finalSubTitle += ' par minute';                break; 
                 case "5 minutes"  : finalSubTitle += ' par tranche de 5 minutes';  break;
                 case "10 minutes" : finalSubTitle += ' par tranche de 10 minutes'; break;
                 case "1 heure"    : finalSubTitle += ' par heure';                 break;
                 case "6 heures"   : finalSubTitle += ' par tranche de 6 heures';   break;
                 case "12 heures"  : finalSubTitle += ' par tranche de 12 heures';  break;
                 // case "1 jour"     : return (session: LiveSession) => ({
                 // case "1 semaine"  : return (session: LiveSession) => ({
                 // case "2 semaines" : return (session: LiveSession) => ({
                 // case "1 mois"     : return (session: LiveSession) => ({
                 // case "6 mois"     : return (session: LiveSession) => ({
                 // case "1 an"       : return (session: LiveSession) => ({
                }
                
               break;
			   
      case 2 : // Semaine courante

               finalSubTitle = `Du ${(convertDateToString (rollingWeekStart ,'dd/MM/yyyy'))} au ${(convertDateToString (now,'dd/MM/yyyy'))}`
               
               switch ( selectedAudienceTimeStep ) 
                {
                 case "1 minute"   : finalSubTitle += ' par minute';                break; 
                 case "5 minutes"  : finalSubTitle += ' par tranche de 5 minutes';  break;
                 case "10 minutes" : finalSubTitle += ' par tranche de 10 minutes'; break;
                 case "1 heure"    : finalSubTitle += ' par heure';                 break;
                 case "6 heures"   : finalSubTitle += ' par tranche de 6 heures';   break;
                 case "12 heures"  : finalSubTitle += ' par tranche de 12 heures';  break;
                 case "1 jour"     : finalSubTitle += ' par jour';                  break;
                 // case "1 semaine"  : return (session: LiveSession) => ({
                 // case "2 semaines" : return (session: LiveSession) => ({
                 // case "1 mois"     : return (session: LiveSession) => ({
                 // case "6 mois"     : return (session: LiveSession) => ({
                 // case "1 an"       : return (session: LiveSession) => ({
                }

               break;

      case 3 : // Mois courant

               finalSubTitle = `Du ${(convertDateToString (currentMonthStart ,'dd/MM/yyyy'))} au ${(convertDateToString (now ,'dd/MM/yyyy'))}`
               
               switch ( selectedAudienceTimeStep ) 
                {
                 case "1 minute"   : finalSubTitle += ' par minute';                break; 
                 case "5 minutes"  : finalSubTitle += ' par tranche de 5 minutes';  break;
                 case "10 minutes" : finalSubTitle += ' par tranche de 10 minutes'; break;
                 case "1 heure"    : finalSubTitle += ' par heure';                 break;
                 case "6 heures"   : finalSubTitle += ' par tranche de 6 heures';   break;
                 case "12 heures"  : finalSubTitle += ' par tranche de 12 heures';  break;
                 case "1 jour"     : finalSubTitle += ' par jour';                  break;
                 case "1 semaine"  : finalSubTitle += ' par semaine';
                 // case "2 semaines" : return (session: LiveSession) => ({
                 // case "1 mois"     : return (session: LiveSession) => ({
                 // case "6 mois"     : return (session: LiveSession) => ({
                 // case "1 an"       : return (session: LiveSession) => ({
                }
                
               break;
               
      default : // Mois courant

               finalSubTitle = `Du ${customStartDate} au ${customEndDate}`
               
               switch ( selectedAudienceTimeStep ) 
                {
                 case "1 minute"   : finalSubTitle += ' par minute';                break; 
                 case "5 minutes"  : finalSubTitle += ' par tranche de 5 minutes';  break;
                 case "10 minutes" : finalSubTitle += ' par tranche de 10 minutes'; break;
                 case "1 heure"    : finalSubTitle += ' par heure';                 break;
                 case "6 heures"   : finalSubTitle += ' par tranche de 6 heures';   break;
                 case "12 heures"  : finalSubTitle += ' par tranche de 12 heures';  break;
                 case "1 jour"     : finalSubTitle += ' par jour';                  break;
                 case "1 semaine"  : finalSubTitle += ' par semaine';               break;
                 case "2 semaines" : finalSubTitle += ' par tranche de 2 semaines'; break;
                 case "1 mois"     : finalSubTitle += ' par mois';                  break;
                 case "6 mois"     : finalSubTitle += ' par tranche de 6 mois';     break;
                 case "1 an"       : finalSubTitle += ' par an';                    break;
                }
                
               break;
     }

    return finalSubTitle
  }

  const handleVisibilityChange = (invisibility : boolean []) => {

    serieVisibilityRef.current = invisibility.map(value => !value);

mergeCoordinates(replayCoordinatesRef.current, liveCoordinatesRef.current);


  };

  const renderAudienceChart = () : JSX.Element => {

    return  <ExtendablePanel logoUrl="/images/logo.png">
                 <div ref={divRefAudienceBlock} className={classNames(styles.audianceChart_line1)}>
                    {
                     widthAudienceBlock > 850 &&
                      <span style={{display: 'inline-block', width: '100px'}}></span>                 
                    }
                    <Select choices  = {periodNames}
                            value    = {selectedAudiencePeriod}
                            onChange = {handleAudiencePeriodChange} />
                    {
                     selectedAudiencePeriod === periodNames[4] &&
         
                        <div className={classNames(styles.audianceChart_line1_customPeriodeChoice)}>
                            <Field value     = {customStartDate}
                                   onChange  = {handleAudiencePeriodStartDateChange}
                                   type      = "calendar"  />
                            <Field value     = {customEndDate}
                                   onChange  = {handleAudiencePeriodEndDateChange}
                                   type      = "calendar"  />
                        </div>
                    }
                    <Select choices  = {timeStepNames}
                            value    = {selectedAudienceTimeStep}
                            onChange = {handleSelectedAudienceTimeStepChange} />
                </div>
                <div className={classNames(styles.audianceChart_line2)}>
                    <CartesianGraph data               = {audienceChartData}
                                    title              = {generateAudienceBarGraphTitle()}
                                    subTitle           = {generateAudienceBarGraphSubTitle()}
                                    colors             = {["var(--color-Graph-Replay)","var(--color-Graph-Live)"]}
                                    titleFontSize      = {24}
                                    subTitleFontSize   = {21}
                                    xAxisLabelFontSize = {15}
                                    yAxisLabelFontSize = {15}
                                    legendFontSize     = {16}
                                    paddingTop         = {110}
                                    paddingBottom      = {100}
                                    paddingLeft        = {100}
                                    width              = {738}
                                    height             = {316}
                                    cumul              = {false}
                                    onVisibilityChange = {handleVisibilityChange}
                                    grapheType         = 'Bar' />
                </div>
            </ExtendablePanel>

  }

  // ~~~~~~ Audience map

  const renderAudienceMap = () : JSX.Element => {

    return <ExtendablePanel logoUrl="/images/logo.png" logoPosition="bottomLeft">
              <OpenStreetMap coordinates={audienceCoordinates} initialZoom={4}/>
           </ExtendablePanel>
  }

  return (
  
    <div className={classNames(styles.root)}>

      <div className={classNames(styles.audienceChart)}>
	    
         <div className={classNames(styles.overlay)}>
			 {showWaitingIcon &&<AnimatedWaitingIcon />}
         </div>
        
        {renderAudienceChart()}
      </div>

      <div className={classNames(styles.audienceMap)}>
	  
         <div className={classNames(styles.overlay)}>
			 {showWaitingIcon &&<AnimatedWaitingIcon />}
         </div>

         <button
           type="button"
           onClick={() => { fetchSessionsDatas(); }}
           title={mapUpdatedAt ? `Actualiser la carte — relevé de ${convertDateToString(mapUpdatedAt, 'HH:mm:ss')}` : 'Actualiser la carte'}
           style={{ position: 'absolute', top: 10, right: 10, zIndex: 7000, width: 28, height: 28, borderRadius: 6, cursor: 'pointer',
                    border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(0,0,0,0.45)', color: '#ffffff', fontSize: 15, lineHeight: 1 }}
         >↻</button>

		 {renderAudienceMap()}
      </div>
      
    </div>
  );
};

export default Audience;
